<template>
    <section>
        <!--工具条-->
        <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
            <el-form :inline="true" :model="filters">
                <el-form-item>
                    <el-input v-model="filters.orderNO" placeholder="订单编号"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="filters.merchantId" placeholder="商家ID"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="filters.provinceIds" clearable style="width:200px;" placeholder="订单区域">
                        <el-option
                                v-for="item in areas"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="filters.masterId" placeholder="工程师ID"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="filters.masterPhone" placeholder="工程师电话"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="filters.workerId" placeholder="员工ID"></el-input>
                </el-form-item>
                <!--
                                <el-form-item>
                                    <el-input v-model="filters.mallOrderNO" placeholder="商城订单号"></el-input>
                                </el-form-item>-->
                <el-form-item>
                    <el-select v-model="filters.state" style="width:150px;" clearable placeholder="订单状态">
                        <el-option
                                v-for="item in orderType"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="filters.merchantPayState" style="width:150px;" clearable placeholder="商家支付状态">
                        <el-option
                                v-for="item in merchantPayStateJSON"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="filters.userPhone" placeholder="用户电话"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="filters.userName" placeholder="用户姓名"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="filters.userProvince" clearable style="width:150px;" placeholder="用户省份">
                        <el-option
                                v-for="item in provinces"
                                :key="item.region_id"
                                :label="item.region_name"
                                :value="item.region_id">
                        </el-option>
                    </el-select>
                </el-form-item>


                <el-form-item>
                    <el-input v-model="filters.finishCode" placeholder="完工码"></el-input>
                </el-form-item>

                <el-form-item>
                    <el-input v-model="filters.carType" placeholder="车型"></el-input>
                </el-form-item>

                <el-form-item>
                    <el-date-picker
                            v-model="date"
                            type="datetimerange"
                            :picker-options="pickerOptions"
                            placeholder="选择日期时间"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            align="right">
                    </el-date-picker>
                </el-form-item>


                <el-form-item>
                    <el-button type="primary" v-on:click="getOrders">查询</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="handleAdd">新增</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="exportExcel">导出Excel</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="danger" v-if="accountType==2" @click="searchMasterWithMap">安装网点查询</el-button>
                </el-form-item>

            </el-form>
        </el-col>


        <el-table :data="orders" highlight-current-row border stripe v-loading="listLoading"
                  @selection-change="selsChange" :row-key="getRowKeys"
                  style="width: 100%;">

            <el-table-column type="expand">
                <template slot-scope="props">
                    <!-- <el-row>
                         <el-col :span="5">
                             <el-tag type="success">用户信息</el-tag>
                         </el-col>
                         <el-col :span="5">
                             <el-tag type="success">下单人信息</el-tag>
                         </el-col>
                         <el-col :span="5">
                             <el-tag type="success">安装人信息</el-tag>
                         </el-col>
                         <el-col :span="5">
                             <el-tag type="success">订单产品详情</el-tag>
                         </el-col>
                         <el-col :span="4">
                             <el-tag type="success">订单状态</el-tag>
                         </el-col>


                     </el-row>-->
                    <el-row>
                        <el-col :span="10">
                            <el-form label-position="left" label-width="90px" class="demo-table-expand">
                                <el-form-item label="商家名称">
                                    <span>{{ props.row.merchantName }}</span>
                                </el-form-item>

                                <el-form-item label="用户姓名">
                                    <span>{{ props.row.userName }}</span>
                                </el-form-item>
                                <el-form-item label="用户电话">
                                    <span>{{ props.row.userPhone }}</span>
                                </el-form-item>
                                <el-form-item label="详细地址">
                                    <span>{{ props.row.regionAddress.replace(/,/g,'')+""+props.row.userAddress }}</span>
                                </el-form-item>
                                <el-form-item label="车型">
                                    <span>{{ props.row.carType }}</span>
                                </el-form-item>
                                <el-form-item label="产品信息">
                                    <span>{{ props.row.productInfo }}</span>
                                </el-form-item>
                                <el-form-item label="技术支持">
                                    <span>{{ props.row.techPhone}}</span>
                                </el-form-item>
                                <el-form-item label="安装费用" v-if="accountType!=2">
                                    <span>{{ props.row.installMoney | formatMoney}}</span>
                                </el-form-item>
                                <el-form-item label="平台费用" v-if="accountType==0">
                                    <span>{{ props.row.platformMoney | formatMoney}}</span>
                                </el-form-item>
                                <el-form-item label="补贴费用" v-if="accountType!=2">
                                    <span>{{ props.row.subsidyMoney | formatMoney}}</span>
                                </el-form-item>
                                <el-form-item label="安装备注">
                                    <span>{{ props.row.installRemark }}</span>
                                </el-form-item>
                                <el-form-item label="订单备注">
                                    <span>{{ props.row.orderRemark.replace(/,/g,'')}}</span>
                                </el-form-item>


                            </el-form>
                        </el-col>

                        <el-col :span="5">
                            <el-form label-position="left" label-width="90px" class="demo-table-expand">
                                <el-form-item label="商城用户ID">
                                    <span>{{ props.row.mallUserId}}</span>
                                </el-form-item>
                                <el-form-item label="商城订单号">
                                    <span>{{ props.row.mallOrderNO}}</span>
                                </el-form-item>
                                <el-form-item label="商家详情" v-if="accountType!=2">
                                    <el-button type="text" size="small"
                                               @click="queryMerchant(props.row)">点击查看
                                    </el-button>
                                </el-form-item>
                                <el-form-item label="付款方式">
                                    <span>{{ props.row.payType | formatPayType}}</span>
                                </el-form-item>
                                <!--<el-form-item label="物流信息">
                                    <span>{{ props.row.logistics }}</span>
                                </el-form-item>-->
                                <el-form-item label="补贴备注" v-if="accountType!=2">
                                    <span>{{ props.row.subsidyremark}}</span>
                                </el-form-item>

                                <!--<el-form-item label="用户地区">
                                    <span>{{ props.row.regionAddress}}</span>
                                </el-form-item>-->

                            </el-form>
                        </el-col>
                        <el-col :span="5">
                            <el-form label-position="left" label-width="90px" class="demo-table-expand">
                                <el-form-item label="指派员工" v-if="accountType!=2">
                                    <el-button v-if="typeof props.row.worker!=='undefined'" type="text"
                                               size="small"
                                               @click="queryCommonUser(props.row)">点击查看
                                    </el-button>
                                    <span v-else>未派单</span>
                                </el-form-item>
                                <el-form-item label="工程师详情" v-if="accountType!=2">
                                    <el-button v-if="typeof props.row.masterId!=='undefined'" type="text" size="small"
                                               @click="queryMasterUser(props.row)">点击查看
                                    </el-button>
                                    <span v-else>未指派</span>
                                </el-form-item>
                                <el-form-item label="安装时间">
                                    <span>{{ props.row.installTime }}</span>
                                </el-form-item>

                                <el-form-item label="安装图片">
                                    <el-button type="text" size="small"
                                               @click="queryImage(props.row)">点击查看
                                    </el-button>
                                </el-form-item>

                            </el-form>
                        </el-col>

                        <el-col :span="4">
                            <el-form label-position="left" label-width="90px" class="demo-table-expand">
                                <el-form-item label="商家支付">
                                    <span>{{ props.row.merchantPayState | formatMerchantPayState}}</span>
                                </el-form-item>
                                <!-- -1	订单取消
                                 0	未指派
                                 1	已指派
                                 2	已完成
                                 3	已评价-->
                                <el-form-item label="订单状态">
                                    <span v-if='props.row.state==0' style="color:red">{{ props.row.state | formatOrderStatus}}</span>
                                    <span v-else='props.row.state==-1' style="color:#3398DB">{{ props.row.state | formatOrderStatus}}</span>
                                    <span v-else style="color:#34bfa3">{{ props.row.state | formatOrderStatus}}</span>
                                </el-form-item>
                                <el-form-item label="订单评分">
                                    <span>{{ props.row.score }}</span>
                                </el-form-item>
                                <el-form-item label="订单评价">
                                    <span>{{ props.row.state }}</span>
                                </el-form-item>
                                <el-form-item label="完工码">
                                    <span>{{ props.row.finishCode }}</span>
                                </el-form-item>
                            </el-form>
                        </el-col>
                    </el-row>
                    </el-form>
                </template>
            </el-table-column>
            <el-table-column type="index" width="55">
            </el-table-column>
            <el-table-column type="selection" width="55">
            </el-table-column>
            <el-table-column prop="orderNO" label="编号" style="text-align: center" :width="accountType!=2?100:''">
            </el-table-column>
            <el-table-column prop="userName" label="车主" style="text-align: center" v-if='accountType==2' width="80">
            </el-table-column>
            <el-table-column prop="userPhone" label="车主电话" style="text-align: center" v-if='accountType==2' width="110">
            </el-table-column>
            <el-table-column prop="carType" label="车型" style="text-align: center" v-if='accountType==2' width="110">
            </el-table-column>
            <el-table-column prop="productInfo" label="安装项目" style="text-align: center" v-if='accountType==2'
                             width="110">
            </el-table-column>


            <el-table-column prop="orderTime" label="订单时间" :width="110">
            </el-table-column>
            <el-table-column prop="installTime" label="结束时间" :width="110">
            </el-table-column>

            <el-table-column prop="merchantId" label="商家ID" v-if='accountType!=2' :formatter="formatMerchantId">
            </el-table-column>
            <el-table-column prop="finishCode" label="完工码" width="85" v-if='accountType!=2'>
            </el-table-column>
            <el-table-column prop="state" label="订单状态" width="170" :formatter="formatOrderStatus">
                <template slot-scope="scope">
                    <el-popover trigger="hover" placement="top">
                        <!-- -1	订单取消
                         0	未指派
                         1	已指派
                         2	已完成
                         3	已评价-->
                        <p>工程师ID: {{ scope.row.masterId }}</p>
                        <p>工程师姓名: {{ scope.row.masterName }}</p>
                        <p>工程师电话: {{ scope.row.masterPhone }}</p>

                        <!--<p>住址: {{ scope.row.address }}</p>-->
                        <div slot="reference" class="name-wrapper">
                            <el-button type='text' style="color:#f4516c;font-size:12px;" v-if='scope.row.state==0'
                                       @click="assignOnlyID(scope.$index, scope.row)">指定工程师 | VIP({{scope.row.vip |
                                formatVip}})
                            </el-button>

                            <span v-else-if='scope.row.state==-1' style="color:#3398DB">{{ scope.row.state | formatOrderStatus}}: {{scope.row.masterId }}</span>
                            <span v-else-if='scope.row.state==2' style="color:#0e0e0e">{{ scope.row.state | formatOrderStatus}}: {{scope.row.masterId }}</span>
                            <el-button type='text' style="color:#34bfa3" v-else-if='scope.row.state==1'
                                       @click="assignOnlyID(scope.$index, scope.row)">{{ scope.row.state |
                                formatOrderStatus}}: {{scope.row.masterId }} | VIP({{scope.row.vip |
                                formatVip}})
                            </el-button>
                            <span v-else style="color:#6673c2">{{ scope.row.state | formatOrderStatus}}: {{scope.row.masterId }}</span>

                            <!--<el-tag>{{ scope.row.state | formatOrderStatus}}</el-tag>-->
                        </div>
                    </el-popover>
                </template>
            </el-table-column>

            <el-table-column prop="workerId" label="员工ID" v-if="accountType!=2" style="text-align: center" width="80">
                <template slot-scope="scope">
                    <el-popover trigger="hover" placement="top">

                        <p>员工ID: {{ scope.row.workerId }}</p>
                        <p>员工姓名: {{ scope.row.workerName }}</p>
                        <!-- <p>员工电话: {{ scope.row.masterPhone }}</p>-->

                        <div slot="reference" class="name-wrapper">

                            <el-tag>{{ scope.row.workerId}}</el-tag>
                        </div>
                    </el-popover>

                </template>


            </el-table-column>

            <el-table-column prop="orderMoney" label="订单费" width="80" :formatter="formatMoney">
            </el-table-column>
            <el-table-column prop="installMoney" label="安装费" v-if="accountType==0" width="80" :formatter="formatMoney">
            </el-table-column>
            <el-table-column prop="subsidyMoney" label="补贴费" v-if="accountType!=2" width="80" :formatter="formatMoney">
            </el-table-column>
            <el-table-column prop="sumMoney" class-name="dd" label="结算费" v-if="accountType!=2" width="80"
                             :formatter="formatSumMoney">
            </el-table-column>
            <el-table-column prop="merchantPayState" label="支付?" style="text-align: center" width="80"
                             :formatter="formatMerchantPayState">
            </el-table-column>
            <el-table-column prop="review" label="回访" width="90">
                <template slot-scope="scope">

                    <el-button type='info' size="small" v-if="scope.row.review==0"
                               @click="review(scope.$index, scope.row)">未回访
                    </el-button>
                    <el-button type='success' size="small" v-else
                               @click="review(scope.$index, scope.row)">已回访
                    </el-button>

                </template>
            </el-table-column>
            <!--<el-table-column prop="platformMoney" label="平台费" width="80" :formatter="formatMoney">
            </el-table-column>-->
            <!--<el-table-column prop="platformMoney" label="补贴费" width="80" :formatter="formatMoney">
            </el-table-column>-->

            <el-table-column label="操作" :width="accountType!=2?210:''">
                <template slot-scope="scope">
                    <el-button type='text' size="small"
                               :style="scope.row.merchantPayState==1?'color:black':'color:#f4516c'"
                               :disabled="scope.row.merchantPayState==1"
                               @click="showPayOrderDialog(scope.$index, scope.row)">
                        {{scope.row.merchantPayState==1?'已经支付':'立即支付'}}
                    </el-button>
                    <el-button type='text' size="small" v-if="accountType!=2" :disabled="scope.row.state==2"
                               @click="assign(scope.$index, scope.row)">派单
                    </el-button>
                    <el-button type='text' size="small" v-if="accountType!=2" :disabled="scope.row.state==2"
                               @click="showSubsidyDialog(scope.$index, scope.row)">补贴费用
                    </el-button>
                    <el-button type="text" size="small" v-if="accountType!=2" :disabled="scope.row.state==2"
                               @click="finishOrder(scope.$index, scope.row)">完成订单
                    </el-button>
                    <el-button type='text' size="small" :disabled="scope.row.state==2"
                               @click="showEditOrder(scope.$index, scope.row)">编辑
                    </el-button>
                    <el-button type='text' size="small"
                               @click="showSMSLog(scope.$index, scope.row)">短信日志
                    </el-button>
                    <el-button type='text' size="small" v-if="accountType!=2" :disabled="scope.row.state!==1"
                               @click="sendSMS(scope.$index, scope.row)">补发短信
                    </el-button>

                    <el-button type="text" size="small" v-if="scope.row.state!=-1"
                               :disabled="scope.row.state==2||(scope.row.state==1&&accountType==2)"
                               @click="showCancelDialog(scope.$index, scope.row)">退订
                    </el-button>
                    <!--<el-button type="text" style='color:#f4516c' size="small" v-else
                               @click="recoverOrder(scope.$index, scope.row)">恢复订单
                    </el-button>-->
                </template>
            </el-table-column>
        </el-table>

        <!--工具条-->
        <el-col :span="24" class="toolbar">
            <el-button type="success" v-if="accountType==2" @click="showBatchPayOrderDialog">批量支付</el-button>
            <!--<el-button type="primary" @click="showMerchantPayDialog">商家对账</el-button>
            <el-button type="primary" @click="showMasterPayDialog">工程师对账</el-button>-->
            <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="rowCount"
                           :total="total" style="float:right;">
            </el-pagination>
        </el-col>

        <!--编辑界面-->
        <el-dialog title="编辑订单" v-model="editFormVisible" :close-on-click-modal="false">
            <el-form :model="editForm" label-width="120px" ref="editForm">
                <!--<el-row v-if="accountType!=2">
                    <el-col>
                        <el-form-item label="所属商家">
                            <span>{{editForm.merchantId-editForm.merchantName}}</span>
                            &lt;!&ndash;<el-select style="width:100%" filterable v-model="editForm.merchantId"
                                       placeholder="请选择商家" @change="getProducts">
                                <el-option
                                        v-for="item in merchant"
                                        :key="item.userId"
                                        :label="item.name"
                                        :value="item.userId">
                                </el-option>
                            </el-select>&ndash;&gt;
                        </el-form-item>
                    </el-col>
                </el-row>-->

                <el-row>
                    <el-col :span="12">
                        <el-form-item label="所属商家">
                            <span>{{editForm.merchantId+"-"+editForm.merchantName}}</span>
                            <!--<el-select style="width:100%" filterable v-model="editForm.merchantId"
                                       placeholder="请选择商家" @change="getProducts">
                                <el-option
                                        v-for="item in merchant"
                                        :key="item.userId"
                                        :label="item.name"
                                        :value="item.userId">
                                </el-option>
                            </el-select>-->
                        </el-form-item>
                    </el-col>
                    <!-- <el-col :span="12">
                         <el-form-item label="车辆品牌" class="require" prop="carBrandIds">
                             &lt;!&ndash;<el-select style="width:100%" filterable v-model="carBrandId"
                                        placeholder="请选择车辆品牌" @change="getCarTypes">
                                 <el-option
                                         v-for="item in carBrands"
                                         :key="item.carBrandId"
                                         :label="item.brandName"
                                         :value="item.carBrandId">
                                 </el-option>
                             </el-select>&ndash;&gt;
                         </el-form-item>
                     </el-col>-->
                    <el-col :span="12">
                        <el-form-item label="车辆型号" class="require" prop="carTypeIds">
                            <span>{{editForm.carType}}</span>
                            <!-- <el-select style="width:100%" filterable v-model="editForm.carTypeId"
                                        placeholder="请选择车辆类型" @change="editGetProductPrice">
                                 <el-option
                                         v-for="item in carTypes"
                                         :key="item.carTypeId"
                                         :label="item.carTypeName"
                                         :value="item.carTypeId">
                                 </el-option>
                             </el-select>-->
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="产品" class="require" prop="productTypes">
                            <!-- <el-select style="width:100%" filterable v-model="editForm.productId"
                                        placeholder="请选择产品" @change="editGetProductPrice">
                                 <el-option
                                         v-for="item in products"
                                         :key="item.productId"
                                         :label="item.productName"
                                         :value="item.productId">
                                 </el-option>
                             </el-select>-->
                            <span>{{editForm.productInfo}}</span>

                        </el-form-item>
                    </el-col>

                    <el-col :span="12">
                        <el-form-item label="订单费用" class="require">
                            <span style="color:palevioletred">{{editForm.orderMoney}}元</span>
                        </el-form-item>
                    </el-col>

                </el-row>

                <el-row>
                    <el-col :span="12">
                        <el-form-item label="用户姓名" class="require">
                            <el-input v-model="editForm.userName" auto-complete="off"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="手机号码" class="require">
                            <el-input v-model="editForm.userPhone" auto-complete="off"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="地区" class="require">
                            <el-cascader style="width:100%;"
                                         v-model="regionId"
                                         placeholder="不选择则使用之前地区"
                                         :options="addProvinces"
                                         @active-item-change="select_ChangeEvent"
                                         :props="props">
                            </el-cascader>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="详细地址" class="require">
                            <el-input v-model="editForm.userAddress" auto-complete="off"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="商城ID">
                            <el-input v-model="editForm.mallUserId" auto-complete="off"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="商城订单号">
                            <el-input v-model="editForm.mallOrderNO" auto-complete="off"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="物流信息">
                            <el-input v-model="editForm.logistics" auto-complete="off"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="订单备注">
                            <el-input type="textarea" v-model="editForm.orderRemark" auto-complete="off"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="安装备注">
                            <el-input type="textarea" v-model="editForm.installRemark" auto-complete="off"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>


            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="editFormVisible = false">取消</el-button>
                <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
            </div>
        </el-dialog>

        <!--新增界面-->
        <el-dialog title="新增订单" v-model="addFormVisible" :close-on-click-modal="false" @close="closeDialog">
            <el-form :model="addForm" label-width="120px" ref="addForm">
                <el-row v-if="accountType==1||accountType==0"><!--商家员工-->
                    <el-col>
                        <el-form-item label="所属商家" class="require">
                            <el-select style="width:100%" filterable v-model="addForm.merchantId"
                                       placeholder="请选择商家" @change="getProducts">
                                <el-option
                                        v-for="item in merchant"
                                        :key="item.userId"
                                        :label="item.userId+' - '+item.name"
                                        :value="item.userId">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="12">

                        <el-form-item label="车辆品牌" class="require" prop="carBrandId">
                            <el-select style="width:100%" filterable v-model="carBrandId"
                                       placeholder="请选择车辆品牌" @change="getCarTypes">
                                <el-option
                                        v-for="item in carBrands"
                                        :key="item.carBrandId"
                                        :label="item.brandName"
                                        :value="item.carBrandId">
                                </el-option>
                            </el-select>

                        </el-form-item>

                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="车辆型号" class="require" prop="carTypeId">

                            <el-select style="width:100%" class="el-select__input" filterable
                                       v-model="addForm.carTypeId"
                                       placeholder="请选择车辆类型" @change="getProductPrice">
                                <el-option
                                        v-for="item in carTypes"
                                        :key="item.carTypeId"
                                        :label="item.carTypeName"
                                        :value="item.carTypeId">
                                </el-option>
                            </el-select>
                        </el-form-item>


                    </el-col>
                </el-row>
                <el-row>

                    <el-col :span="12">
                        <el-form-item label="产品" class="require" prop="productType">
                            <el-select style="width:100%" filterable v-model="addForm.productId"
                                       placeholder="请选择产品" @change="getProductPrice">
                                <el-option
                                        v-for="item in products"
                                        :key="item.productId"
                                        :label="item.productName"
                                        :value="item.productId">
                                </el-option>
                            </el-select>

                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="订单费用">
                            <span style="color:palevioletred">{{orderMoney}}元</span>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="12">
                        <el-form-item label="用户姓名" class="require">
                            <el-input v-model="addForm.userName" auto-complete="off"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="手机号码" class="require">
                            <el-input v-model="addForm.userPhone" auto-complete="off"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="地区" class="require">
                            <el-cascader style="width:100%;"
                                         size="medium"
                                         v-model="regionId"
                                         placeholder="地区"
                                         :options="addProvinces"
                                         @active-item-change="select_ChangeEvent"
                                         :props="props">
                            </el-cascader>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="详细地址" class="require">
                            <el-input v-model="addForm.userAddress" auto-complete="off"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="商城ID">
                            <el-input v-model="addForm.mallUserId" auto-complete="off"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="商城订单号">
                            <el-input v-model="addForm.mallOrderNO" auto-complete="off"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="物流信息">
                            <el-input v-model="addForm.logistics" auto-complete="off"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="订单备注">
                            <el-input type="textarea" v-model="addForm.orderRemark" auto-complete="off"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="安装备注">
                            <el-input type="textarea" v-model="addForm.installRemark" auto-complete="off"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>


            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="addFormVisible = false">取消</el-button>
                <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
            </div>
        </el-dialog>

        <!--图片展示界面-->
        <el-dialog title="查看图片" v-model="queryImageVisible" :close-on-click-modal="false" customClass="customWidth">

            <el-form label-width="120px" style="width:100%">
                <el-form-item label="门头相片">

                    <img :src="item" v-for="item in images"/>

                </el-form-item>
            </el-form>
        </el-dialog>

        <!--派单界面-->
        <el-dialog title="派单" customClass="assignWidth" v-model="assignFormVisible" :close-on-click-modal="false">
            <el-form :model="assignForm" label-width="120px">

                <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
                    <el-form :inline="true" :model="assignFilters">

                        <el-form-item>
                            <el-input style="width:400px;" v-model="assignFilters.address"
                                      placeholder="输入地区搜索,不输入则搜索默认地址">
                                <el-button slot="append" icon="search" @click="getPoi()"></el-button>
                            </el-input>
                            <span style="color:#f4516c;font-size:16px;">已指派工程师:{{assignForm.masterId==''?'还未指派':assignForm.masterId}}</span>

                            <!--<el-button type="success" @click="getOrderInfoInMap">订单信息</el-button>-->
                        </el-form-item>
                    </el-form>
                </el-col>
                <div id="container" class="map">

                </div>

                <el-table :data="masterUsers" highlight-current-row border stripe v-loading="listLoading"
                          style="width: 100%;">

                    <el-table-column type="expand">
                        <template slot-scope="props">
                            <el-row>

                                <el-col :span="8">
                                    <el-form label-position="left" class="demo-table-expand">
                                        <el-form-item label="付款账号">
                                            <span>{{ props.row.logistics }}</span>
                                        </el-form-item>

                                        <el-form-item label="营业时间">
                                            <span>{{ props.row.workTime }}</span>
                                        </el-form-item>
                                        <el-form-item label="服务类型">
                                            <span>{{ props.row.serviceType | formatServiceType}}</span>
                                        </el-form-item>
                                        <el-form-item label="备注">
                                            <span>{{ props.row.remark }}</span>
                                        </el-form-item>

                                    </el-form>
                                </el-col>
                                <el-col :span="8">
                                    <el-form label-position="left" class="demo-table-expand">
                                        <el-form-item label="图片详情">

                                            <el-button type="success" size="small"
                                                       @click="queryImage(props.row)">点击查看
                                            </el-button>

                                        </el-form-item>

                                        <el-form-item label="经营主体">
                                            <span>{{ props.row.storeInfo }}</span>
                                        </el-form-item>
                                        <el-form-item label="技能标签">
                                            <span>{{ `${typeof props.row.skills=='undefined'?'':props.row.skillsDesc}` }}</span>
                                        </el-form-item>

                                    </el-form>
                                </el-col>
                                <el-col :span="8">
                                    <el-form label-position="left" class="demo-table-expand">
                                        <el-form-item label="等级-积分">
                                            <span>{{ props.row.level | formatLevel}}-{{props.row.score}}</span>
                                        </el-form-item>
                                        <el-form-item label="面试方式">
                                            <span>{{ props.row.interviewType | formatInterview}}</span>
                                        </el-form-item>
                                        <el-form-item label="邀请码">
                                            <span>{{ props.row.recommendCode }}</span>
                                        </el-form-item>
                                        <el-form-item label="详细地址">
                                            <span>{{ props.row.address }}</span>
                                        </el-form-item>
                                    </el-form>

                                </el-col>
                            </el-row>
                        </template>
                    </el-table-column>

                    <el-table-column prop="masterId" label="工程师ID" width="100">
                    </el-table-column>
                    <el-table-column prop="level" label="等级" width="120" :formatter="formatLevel">
                    </el-table-column>
                    <el-table-column prop="lastLoginTime" label="是否关注" width="120" :formatter="formatLastLoginTime">
                    </el-table-column>
                    <el-table-column prop="storeName" label="店铺名称">
                    </el-table-column>
                    <el-table-column prop="distance" label="距离" width="110" :formatter="formatDistance">
                    </el-table-column>
                    <el-table-column prop="phone" label="手机号码" width="130">
                    </el-table-column>
                    <el-table-column prop="name" label="姓名" width="130">
                    </el-table-column>
                    <el-table-column prop="remark" label="备注" width="150">
                    </el-table-column>
                    <!--<el-table-column prop="joinTime" label="加入时间" width="200">
                    </el-table-column>-->
                    <el-table-column label="详细地址">
                        <template slot-scope="scope">
                            <span>{{scope.row.regionAddress.replace(/,/g,'')+""+scope.row.address}}</span>
                        </template>

                    </el-table-column>
                    <!--<el-table-column prop="money" label="余额" width="80" :formatter="formatMoney">
                    </el-table-column>-->
                    <el-table-column prop="orderCount" label="订单量" width="80">
                        <template slot-scope="scope">
                            <el-button type='info' size="small" :disabled="scope.row.orderCount==0"
                                       @click="masterDetailOrder(scope.$index, scope.row)">查看:{{scope.row.orderCount}}
                            </el-button>
                        </template>

                    </el-table-column>

                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button type="success" size="small"
                                       @click="confirmAssignSubmit(scope.$index, scope.row)">
                                确认指派
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>

            </el-form>


        </el-dialog>

        <!--根据工程师查询订单量-->
        <el-dialog title="订单详情" customClass="assignWidth" v-model="masterDetailOrderVisible"
                   :close-on-click-modal="false">

            <el-table :data="masterDetailOrders" highlight-current-row border stripe
                      :row-key="getRowKeys"
                      style="width: 100%;">

                <el-table-column type="expand">
                    <template slot-scope="props">

                        <el-row>
                            <el-col :span="5">
                                <el-form label-position="left" label-width="120px" class="demo-table-expand">
                                    <el-form-item label="商城用户ID">
                                        <span>{{ props.row.mallUserId}}</span>
                                    </el-form-item>
                                    <el-form-item label="商城订单号">
                                        <span>{{ props.row.mallOrderNO}}</span>
                                    </el-form-item>

                                    <el-form-item label="用户姓名">
                                        <span>{{ props.row.userName }}</span>
                                    </el-form-item>
                                    <el-form-item label="用户电话">
                                        <span>{{ props.row.userPhone }}</span>
                                    </el-form-item>
                                    <el-form-item label="详细地址">
                                        <span>{{ props.row.regionAddress.replace(/,/g,'')+""+props.row.userAddress }}</span>
                                    </el-form-item>
                                </el-form>

                            </el-col>
                            <el-col :span="5">
                                <el-form label-position="left" class="demo-table-expand">
                                    <!-- <el-form-item label="商家详情" v-if="accountType!=2">
                                         <el-button type="text" size="small"
                                                    @click="queryMerchant(props.row)">点击查看
                                         </el-button>
                                     </el-form-item>-->
                                    <el-form-item label="付款方式">
                                        <span>{{ props.row.payType | formatPayType}}</span>
                                    </el-form-item>
                                    <el-form-item label="物流信息">
                                        <span>{{ props.row.logistics }}</span>
                                    </el-form-item>
                                    <el-form-item label="订单备注">
                                        <span>{{ props.row.orderRemark }}</span>
                                    </el-form-item>
                                    <!--<el-form-item label="用户地区">
                                        <span>{{ props.row.regionAddress}}</span>
                                    </el-form-item>-->

                                </el-form>
                            </el-col>
                            <el-col :span="5">
                                <el-form label-position="left" class="demo-table-expand">
                                    <el-form-item label="指派员工" v-if="accountType!=2">
                                        <el-button v-if="typeof props.row.worker!=='undefined'" type="text"
                                                   size="small"
                                                   @click="queryCommonUser(props.row)">点击查看
                                        </el-button>
                                        <span v-else>未派单</span>
                                    </el-form-item>
                                    <!--<el-form-item label="工程师详情" v-if="accountType!=2">
                                        <el-button v-if="typeof props.row.masterId!=='undefined'" type="text" size="small"
                                                   @click="queryMasterUser(props.row)">点击查看
                                        </el-button>
                                        <span v-else>未指派</span>
                                    </el-form-item>-->
                                    <el-form-item label="安装时间">
                                        <span>{{ props.row.installTime }}</span>
                                    </el-form-item>
                                    <el-form-item label="安装备注">
                                        <span>{{ props.row.productInfo }}</span>
                                    </el-form-item>
                                    <el-form-item label="安装图片">
                                        <el-button type="text" size="small"
                                                   @click="queryImage(props.row)">点击查看
                                        </el-button>
                                    </el-form-item>

                                </el-form>
                            </el-col>
                            <el-col :span="5">
                                <el-form label-position="left" class="demo-table-expand">
                                    <el-form-item label="车型">
                                        <span>{{ props.row.carType }}</span>
                                    </el-form-item>
                                    <el-form-item label="产品信息">
                                        <span>{{ props.row.productInfo }}</span>
                                    </el-form-item>
                                    <el-form-item label="订单费用">
                                        <span>{{ props.row.orderMoney | formatMoney}}</span>
                                    </el-form-item>
                                    <el-form-item label="安装费用" v-if="accountType!=2">
                                        <span>{{ props.row.installMoney | formatMoney}}</span>
                                    </el-form-item>
                                    <el-form-item label="平台费用" v-if="accountType!=2">
                                        <span>{{ props.row.platformMoney | formatMoney}}</span>
                                    </el-form-item>
                                    <el-form-item label="补贴费用" v-if="accountType!=2">
                                        <span>{{ props.row.subsidyMoney | formatMoney}}</span>
                                    </el-form-item>

                                    <el-form-item label="补贴备注" v-if="accountType!=2">
                                        <span>{{ props.row.subsidyremark}}</span>
                                    </el-form-item>

                                </el-form>
                            </el-col>
                            <el-col :span="4">
                                <el-form label-position="left" class="demo-table-expand">
                                    <el-form-item label="商家支付">
                                        <span>{{ props.row.merchantPayState | formatMerchantPayState}}</span>
                                    </el-form-item>
                                    <!-- -1	订单取消
                                     0	未指派
                                     1	已指派
                                     2	已完成
                                     3	已评价-->
                                    <el-form-item label="订单状态">
                                        <span v-if='props.row.state==0' style="color:red">{{ props.row.state | formatOrderStatus}}</span>
                                        <span v-else='props.row.state==-1' style="color:#3398DB">{{ props.row.state | formatOrderStatus}}</span>
                                        <span v-else
                                              style="color:#34bfa3">{{ props.row.state | formatOrderStatus}}</span>
                                    </el-form-item>
                                    <el-form-item label="订单评分">
                                        <span>{{ props.row.score }}</span>
                                    </el-form-item>
                                    <el-form-item label="订单评价">
                                        <span>{{ props.row.state }}</span>
                                    </el-form-item>
                                    <el-form-item label="完工码">
                                        <span>{{ props.row.finishCode }}</span>
                                    </el-form-item>
                                </el-form>
                            </el-col>
                        </el-row>
                        </el-form>
                    </template>
                </el-table-column>
                <el-table-column prop="orderNO" label="订单编号" style="text-align: center" width="200">
                </el-table-column>
                <el-table-column prop="orderTime" label="订单时间" width="200">
                </el-table-column>

                <el-table-column prop="merchantId" label="商家ID" :formatter="formatMerchantId">
                </el-table-column>
                <el-table-column prop="state" label="订单状态" width="100" :formatter="formatOrderStatus">
                    <template slot-scope="scope">
                        <el-popover trigger="hover" placement="top">
                            <!-- -1	订单取消
                             0	未指派
                             1	已指派
                             2	已完成
                             3	已评价-->
                            <p>工程师ID: {{ scope.row.masterId }}</p>
                            <p>工程师姓名: {{ scope.row.masterName }}</p>
                            <p>工程师电话: {{ scope.row.masterPhone }}</p>
                            <!--<p>住址: {{ scope.row.address }}</p>-->
                            <div slot="reference" class="name-wrapper">
                            <span v-if='scope.row.state==0'
                                  style="color:#f4516c">{{ scope.row.state | formatOrderStatus}}:{{scope.row.workerId}}</span>
                                <span v-else-if='scope.row.state==-1' style="color:#3398DB">{{ scope.row.state | formatOrderStatus}}:{{scope.row.workerId}}</span>
                                <span v-else-if='scope.row.state==2' style="color:#0e0e0e">{{ scope.row.state | formatOrderStatus}}:{{scope.row.workerId}}</span>
                                <span v-else-if='scope.row.state==1' style="color:#34bfa3">{{ scope.row.state | formatOrderStatus}}:{{scope.row.workerId}}</span>
                                <span v-else style="color:#6673c2">{{ scope.row.state | formatOrderStatus}}:{{scope.row.workerId}}</span>

                                <!--<el-tag>{{ scope.row.state | formatOrderStatus}}</el-tag>-->
                            </div>
                        </el-popover>
                    </template>
                </el-table-column>

                <el-table-column prop="workerId" label="员工ID" v-if="accountType!=2" style="text-align: center"
                                 width="80">

                </el-table-column>

                <el-table-column prop="productInfo" label="产品信息" width="120">
                </el-table-column>
                <el-table-column prop="installMoney" label="安装费" v-if="accountType!=2" width="80"
                                 :formatter="formatMoney">
                </el-table-column>
                <el-table-column prop="subsidyMoney" label="补贴费" v-if="accountType!=2" width="80"
                                 :formatter="formatMoney">
                </el-table-column>
                <el-table-column prop="merchantPayState" label="支付状态" style="text-align: center" width="100"
                                 :formatter="formatMerchantPayState">
                </el-table-column>
                <el-table-column prop="review" label="回访" width="100" :formatter="formatMoney">
                    <template slot-scope="scope">
                        <el-button type='info' size="small" v-if="scope.row.review==0"
                                   @click="review(scope.$index, scope.row)">未回访
                        </el-button>
                        <el-button type='success' size="small" v-else
                                   @click="review(scope.$index, scope.row)">已回访
                        </el-button>
                    </template>
                </el-table-column>
                <!--<el-table-column prop="platformMoney" label="平台费" width="80" :formatter="formatMoney">
                </el-table-column>-->
                <!--<el-table-column prop="platformMoney" label="补贴费" width="80" :formatter="formatMoney">
                </el-table-column>-->


            </el-table>

        </el-dialog>

        <!--确认派单界面-->
        <el-dialog title="确认派单" v-model="confirmAssignVisible" :close-on-click-modal="false">
            <el-form :model="confirmAssignForm" label-width="130px" ref="confirmAssignForm">
                <el-form-item label="安装费用" class="require">
                    <el-input type="number" placeholder="请输入安装费用" auto-complete="off"
                              v-model="confirmAssignForm.installMoney"></el-input>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="confirmAssignVisible = false">取消</el-button>
                <el-button type="primary" @click.native="confirmAssignSubmit">更新
                </el-button>
            </div>
        </el-dialog>

        <!--补贴费用界面-->
        <el-dialog title="补贴费用" v-model="subsidyVisible" :close-on-click-modal="false">
            <el-form :model="subsidyForm" label-width="130px" ref="subsidyForm">
                <el-form-item label="补贴费用" class="require" prop="subsidyMoney">
                    <el-input type="number" placeholder="请输入补贴费用" auto-complete="off"
                              v-model="subsidyForm.subsidyMoney"></el-input>
                </el-form-item>
                <el-form-item label="备注" class="require" prop="subsidyRemark">
                    <el-input placeholder="请输入备注" auto-complete="off"
                              v-model="subsidyForm.subsidyRemark"></el-input>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="subsidyVisible = false">取消</el-button>
                <el-button type="primary" @click.native="subsidySubmit">提交
                </el-button>
            </div>
        </el-dialog>

        <!--派单指定ID-->
        <el-dialog title="指定工程师" v-model="assignIDVisible" :close-on-click-modal="false">
            <el-form :model="assignIDForm" label-width="130px">
                <el-form-item label="工程师ID" class="require" prop="masterId">
                    <el-input type="number" placeholder="输入工程师ID" auto-complete="off"
                              v-model="assignIDForm.masterId"></el-input>
                </el-form-item>


            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="assignIDVisible = false">取消</el-button>
                <el-button type="primary" @click.native="assignIDSubmit">提交
                </el-button>
            </div>
        </el-dialog>

        <!--订单退订界面-->
        <el-dialog title="订单退订" v-model="cancelOrderVisible" :close-on-click-modal="false">
            <el-form :model="cancelOrderForm" label-width="130px" ref="cancelOrderForm">

                <el-form-item label="备注" class="require" prop="cancelOrderRemark">
                    <el-input placeholder="请输入备注" auto-complete="off"
                              v-model="cancelOrderForm.cancelRemark"></el-input>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="cancelOrderVisible = false">取消</el-button>
                <el-button type="primary" @click.native="cancelOrderSubmit">提交
                </el-button>
            </div>
        </el-dialog>

        <!--回访界面-->
        <el-dialog title="回访" customClass="customWidth" v-model="reviewVisible" :close-on-click-modal="false">
            <el-form :model="reviewForm" label-width="130px" ref="reviewForm" v-if="accountType!=2">

                <el-form-item label="回访内容" class="require" prop="remark">
                    <el-input placeholder="请输入回访内容" auto-complete="off"
                              v-model="reviewForm.remark"></el-input>
                </el-form-item>
                <el-form-item label="是否保密" class="require" prop="isPublic">
                    <el-switch
                            v-model="reviewForm.isPublic"
                            on-color="#13ce66"
                            on-text="公开"
                            off-text="保密"
                            off-color="#ff4949">
                    </el-switch>
                </el-form-item>
            </el-form>
            <el-table :data="reviews" highlight-current-row border stripe v-loading="listLoading"
                      style="width: 100%;">

                <el-table-column type="index" width="60">
                </el-table-column>
                <!-- userId	操作用户id
                 userName	操作用户姓名
                 isPublic	是否公开
                 reviewTime	回访时间
                 remark	回访备注-->
                <el-table-column prop="userId" label="操作用户ID" width="120">
                </el-table-column>
                <el-table-column prop="userName" label="用户姓名" width="100">
                </el-table-column>
                <el-table-column prop="reviewTime" label="时间" width="170">
                </el-table-column>
                <el-table-column prop="remark" label="内容" min-width="100">
                </el-table-column>

            </el-table>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="reviewVisible = false">取消</el-button>
                <el-button type="primary" v-if="accountType!=2" @click.native="reviewSubmit">提交
                </el-button>
            </div>

        </el-dialog>

        <!--支付界面-->
        <el-dialog title="支付订单" v-model="payOrderVisible" :close-on-click-modal="false">

            <el-form :model="payOrderForm" label-width="130px" ref="payOrderForm">

                <el-form-item label="订单编号" class="require">
                    <el-input type="textarea" :rows="8" placeholder="按一竖列输入订单编号" auto-complete="off"
                              v-model="payOrderForm.orderNOs"></el-input>
                </el-form-item>

                <el-form-item label="备注">
                    <el-input type="textarea" :rows="2" auto-complete="off"
                              v-model="payOrderForm.remark"></el-input>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="payOrderVisible = false">取消</el-button>
                <el-button type="primary" @click.native="payOrderSubmit">立即支付
                </el-button>
            </div>
        </el-dialog>

        <!--短信日志-->
        <el-dialog title="短信日志" v-model="SMSLogVisible" :close-on-click-modal="false" customClass="customWidth">

            <el-table :data="smsLogDatas" highlight-current-row border stripe v-loading="listLoading"
                      @selection-change="selsChange"
                      style="width: 100%;text-align: center">

                <el-table-column type="index" width="60">
                </el-table-column>
                <el-table-column prop="orderNO" label="订单编号" width="180">
                </el-table-column>
                <el-table-column prop="masterPhone" label="工程师电话" width="180">
                </el-table-column>
                <el-table-column prop="masterName" label="工程师姓名" width="200">
                </el-table-column>
                <el-table-column prop="smsContent" label="内容" style="text-align: left;color:red" min-width="205">
                </el-table-column>
            </el-table>
        </el-dialog>


        <!--地图搜索工程师-->
        <el-dialog title="搜索工程师" customClass="assignWidth" v-model="searchMasterWithMapVisible"
                   :close-on-click-modal="false">
            <el-form label-width="120px">

                <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
                    <el-form :inline="true" :model="searchMasterWithMapFilters">

                        <el-form-item>
                            <el-input style="width:400px;" v-model="searchMasterWithMapFilters.address"
                                      placeholder="输入详细市名+地址搜索">
                                <el-button slot="append" icon="search"
                                           @click="getPoi_searchMasterWithMap()"></el-button>
                            </el-input>
                        </el-form-item>
                    </el-form>
                </el-col>
                <div id="container_searchMasterWithMap" class="map">

                </div>

                <el-table :data="masterUsers_searchMasterWithMap" highlight-current-row border stripe
                          v-loading="listLoading"
                          style="width: 100%;">

                    <el-table-column type="expand">
                        <template slot-scope="props">
                            <el-row>

                                <el-col :span="8">
                                    <el-form label-position="left" class="demo-table-expand">
                                        <el-form-item label="付款账号">
                                            <span>{{ props.row.logistics }}</span>
                                        </el-form-item>

                                        <el-form-item label="营业时间">
                                            <span>{{ props.row.workTime }}</span>
                                        </el-form-item>
                                        <el-form-item label="服务类型">
                                            <span>{{ props.row.serviceType | formatServiceType}}</span>
                                        </el-form-item>
                                        <el-form-item label="备注">
                                            <span>{{ props.row.remark }}</span>
                                        </el-form-item>

                                    </el-form>
                                </el-col>
                                <el-col :span="8">
                                    <el-form label-position="left" class="demo-table-expand">
                                        <el-form-item label="图片详情">

                                            <el-button type="success" size="small"
                                                       @click="queryImage(props.row)">点击查看
                                            </el-button>

                                        </el-form-item>

                                        <el-form-item label="经营主体">
                                            <span>{{ props.row.storeInfo }}</span>
                                        </el-form-item>
                                        <el-form-item label="技能标签">
                                            <span>{{ `${typeof props.row.skills=='undefined'?'':props.row.skillsDesc}` }}</span>
                                        </el-form-item>

                                    </el-form>
                                </el-col>
                                <el-col :span="8">
                                    <el-form label-position="left" class="demo-table-expand">
                                        <el-form-item label="等级-积分">
                                            <span>{{ props.row.level | formatLevel}}-{{props.row.score}}</span>
                                        </el-form-item>
                                        <el-form-item label="面试方式">
                                            <span>{{ props.row.interviewType | formatInterview}}</span>
                                        </el-form-item>
                                        <el-form-item label="邀请码">
                                            <span>{{ props.row.recommendCode }}</span>
                                        </el-form-item>
                                        <el-form-item label="详细地址">
                                            <span>{{ props.row.address }}</span>
                                        </el-form-item>
                                    </el-form>

                                </el-col>
                            </el-row>
                        </template>
                    </el-table-column>

                    <el-table-column prop="masterId" label="工程师ID" width="100">
                    </el-table-column>
                    <el-table-column prop="level" label="等级" width="120" :formatter="formatLevel">
                    </el-table-column>
                    <!-- <el-table-column prop="lastLoginTime" label="是否关注" width="120" :formatter="formatLastLoginTime">
                     </el-table-column>-->
                    <el-table-column prop="storeName" label="店铺名称">
                    </el-table-column>
                    <el-table-column prop="distance" label="距离" width="110" :formatter="formatDistance">
                    </el-table-column>
                    <!--<el-table-column prop="phone" label="手机号码" width="130">
                    </el-table-column>-->
                    <el-table-column prop="name" label="姓名" width="130">
                    </el-table-column>
                    <!--<el-table-column prop="remark" label="备注" width="150">
                    </el-table-column>-->
                    <!--<el-table-column prop="joinTime" label="加入时间" width="200">
                    </el-table-column>-->
                    <el-table-column label="详细地址">
                        <template slot-scope="scope">
                            <span>{{scope.row.regionAddress.replace(/,/g,'')+""+scope.row.address}}</span>
                        </template>

                    </el-table-column>
                    <!--<el-table-column prop="money" label="余额" width="80" :formatter="formatMoney">
                    </el-table-column>-->
                    <!-- <el-table-column prop="orderCount" label="订单量" width="80">
                         <template slot-scope="scope">
                             <el-button type='info' size="small" :disabled="scope.row.orderCount==0"
                                        @click="masterDetailOrder(scope.$index, scope.row)">查看:{{scope.row.orderCount}}
                             </el-button>
                         </template>

                     </el-table-column>-->

                </el-table>

            </el-form>


        </el-dialog>


        <!--商家对账界面-->
        <!--<el-dialog title="商家对账" v-model="batchMerchantPayVisible" :close-on-click-modal="false">
            <el-form :model="batchMerchantPayForm" label-width="130px" ref="batchMerchantPayForm">
                <el-form-item label="订单编号">
                    <el-input type="textarea" :rows="8" placeholder="一竖列输入订单编号" auto-complete="off"
                              v-model="batchMerchantPayForm.orderNOs"></el-input>
                </el-form-item>

                <el-form-item label="备注">
                    <el-input type="textarea" :rows="2" auto-complete="off"
                              v-model="batchMerchantPayForm.merchantPayRemark"></el-input>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="batchMerchantPayVisible = false">取消</el-button>
                <el-button type="primary" @click.native="merchantPaySubmit">更新
                </el-button>
            </div>
        </el-dialog>-->

        <!--工程师对账界面-->
        <!--<el-dialog title="商家对账" v-model="batchMasterPayVisible" :close-on-click-modal="false">
            <el-form :model="batchMasterPayForm" label-width="130px" ref="batchMasterPayForm">
                <el-form-item label="订单编号">
                    <el-input type="textarea" :rows="8" placeholder="一竖列输入订单编号" auto-complete="off"
                              v-model="batchMasterPayForm.orderNOs"></el-input>
                </el-form-item>

                <el-form-item label="对账状态">
                    <el-radio class="radio" v-model="batchMasterPayForm.masterPayState" label="1">私下支付</el-radio>
                    <el-radio class="radio" v-model="batchMasterPayForm.masterPayState" label="2">转入个人余额</el-radio>
                </el-form-item>

                <el-form-item label="备注">
                    <el-input type="textarea" :rows="2" auto-complete="off"
                              v-model="batchMasterPayForm.masterPayRemark"></el-input>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="batchMasterPayVisible = false">取消</el-button>
                <el-button type="primary" @click.native="batchMasterPaySubmit">更新
                </el-button>
            </div>
        </el-dialog>-->

        <form ref="exportEx" method="post" target="_blank"
              style="display: none">
            <input type="text" ref="token" name="token">
        </form>

    </section>
</template>

<script>
    import util from '../../common/js/util'
    import NProgress from 'nprogress'
    import {requestPost} from '../../api/api';
    import {data} from "../../common/data";
    import {TMap} from '../../api/map'
    import gongImg from '@/assets/gong.png'
    import dingImg from '@/assets/ding.png'

    export default {
        data() {
            return {
                accountType: sessionStorage.getItem('type'),
                filters: {
                    merchantId: '',
                    workerId: '',
                    state: '',
                    orderNO: '',
                    masterId: '',
                    finishCode: '',
                    userPhone: '',
                    provinceIds: '',
                    userProvince: '',
                    orderStartTime: '',
                    orderEndTime: '',
                    mallOrderNO: '',
                    userName: '',
                    merchantPayState: '',
                    masterPhone: '',
                    carType:''

                },
                orders: [],
                total: 0,
                rowCount: 30,
                pageNO: 1,
                orderType: data.orderType,
                merchantPayStateJSON: data.merchantPayStateJSON,
                listLoading: false,
                sels: [],

                provinces: [],
                areas: data.areas,
                level: data.level,
                interview: data.interview,
                pickerOptions: data.pickerOPtions,
                date: '',

                editFormVisible: false,
                editLoading: false,
                editForm: {
                    carType: '',
                    productInfo: '',
                    orderMoney: '',
                    merchantId: '',
                    orderRemark: '',
                    userName: '',
                    userPhone: '',
                    userProvince: '',
                    userCity: '',
                    userArea: '',
                    userAddress: '',
                    mallUserId: '',
                    mallOrderNO: '',
                    logistics: '',
                    installRemark: ''

                },

                addFormVisible: false,
                addLoading: false,
                images: [],
                products: [],
                carTypes: [],
                carBrands: [],
                carBrandId: '',
                queryImageVisible: false,
                orderMoney: 0,
                editOrderMoney: 0,
                addForm: {
                    merchantId: '',
                    orderRemark: '',
                    carTypeId: '',
                    productId: '',
                    userName: '',
                    userPhone: '',
                    userProvince: '',
                    userCity: '',
                    userArea: '',
                    userAddress: '',
                    mallUserId: '',
                    mallOrderNO: '',
                    logistics: '',
                    installRemark: ''

                },
                addProvinces: [],
                regionId: [],
                props: {
                    value: 'region_id',
                    label: 'region_name',
                    children: 'cities'
                },

                assignFormVisible: false,
                searchMasterWithMapVisible: false,
                assignForm: {
                    orderId: '',
                    masterId: '',

                },
                masterUsers: [],
                masterUsers_searchMasterWithMap: [],

                batchMerchantPayVisible: false,
                batchMasterPayVisible: false,

                batchMerchantPayForm: {
                    orderNOs: '',
                    merchantPayRemark: '',
                    merchantPayState: ''
                },

                batchMasterPayForm: {
                    orderNOs: '',
                    masterPayState: '1',
                    masterPayRemark: ''
                },
                merchant: [],
                confirmAssignVisible: false,
                confirmAssignForm: {
                    installMoney: 0,
                    masterId: ''
                },
                assignFilters: {
                    address: "",
                    radius: 20000
                },
                searchMasterWithMapFilters: {
                    address: "",
                    radius: 20000
                },
                map: null,
                gongImg,
                dingImg,
                subsidyVisible: false,
                subsidyForm: {
                    orderId: '',
                    subsidyMoney: '',
                    subsidyRemark: ''
                },
                cancelOrderVisible: false,
                cancelOrderForm: {
                    orderId: '',
                    cancelRemark: ''

                },
                reviewVisible: false,
                reviewForm: {
                    orderId: '',
                    isPublic: true,
                    remark: ''
                },
                reviews: [],
                payOrderVisible: false,
                payOrderForm: {
                    rechargeType: 1,
                    orderNOs: '',
                    remark: '',
                    userId: ''
                },
                // 获取row的key值
                getRowKeys(row) {
                    return row.orderId
                },
                SMSLogVisible: false,
                smsLogDatas: [],
                orderInfoInMap: null,
                orderInfoInMapVisible: false,

                masterDetailOrderVisible: false,
                masterDetailOrders: [],

                assignIDVisible: false,
                assignIDForm: {
                    masterId: '',
                    orderId: ''
                }


            }
        },


        filters: {
            formatMoney: function (value) {
                if (value)
                    return value / 100 + ' 元';
                else return 0 + "元";
            },
            formatOrderStatus(value) {
                return data.orderStatus[value + 1]
            },
            formatMerchantPayState(value) {
                return data.merchantPayState[value]
            },
            formatMasterPayState(value) {
                return data.masterPayState[value]
            },
            formatPayType(value) {
                return data.payType[value]
            },
            formatServiceType(value) {
                return data.serviceType[value];
            },
            formatLevel(value) {
                return data.level[value].label
            },
            formatInterview(value) {
                return data.interview[value]
            },
            formatVip(value) {
                return data.vipLabel[value]
            }


        },


        methods: {

            formatSumMoney: function (row) {

                return row.installMoney / 100 + row.subsidyMoney / 100;

            },
            formatDistance(row) {
                return `${row.distance / 1000}公里`;
            },
            formatLevel(row) {
                return data.level[row.level].label
            },
            formatLastLoginTime(row) {
                if (row.lastLoginTime) return '是';
                else return '否';
            },
            formatServiceType(row) {
                return data.serviceType[row.serviceType];
            },
            formatOrderStatus(row, column) {
                return data.orderStatus[row.state + 1]
            },
            formatMerchantPayState(row, column) {
                return data.merchantPayState[row.merchantPayState]
            },

            formatMerchantId(row, column) {
                return `${row.merchantId}-${row.merchantName}`
            },
            formatAddress(row, column) {
                return `${row.userProvince} ${row.userCity} ${row.userArea} ${row.userAddress}`;
            },
            formatMoney(row, column) {

                if (row.orderMoney && column.label == '订单费') {
                    return row.orderMoney / 100;
                } else if (row.installMoney && column.label == '安装费') {
                    return row.installMoney / 100;
                } else if (row.subsidyMoney && column.label == '补贴费') {
                    return row.subsidyMoney / 100;
                } else return 0;

            },
            closeDialog() {

                this.addForm = {
                    merchantId: '',
                    orderRemark: '',
                    carTypeId: '',
                    productId: '',
                    userName: '',
                    userPhone: '',
                    userProvince: '',
                    userCity: '',
                    userArea: '',
                    userAddress: '',
                    mallUserId: '',
                    mallOrderNO: '',
                    logistics: '',
                    installRemark: ''

                }
            },

            showMasterPayDialog() {
                this.batchMasterPayVisible = true;
                var orderNOs = this.sels.map(item => item.orderNO).toString();
                this.batchMasterPayForm.orderNOs = orderNOs.replace(/\,/g, '\r\n');

            },

            showSMSLog(index, row) {

                this.smsLogDatas = [];

                NProgress.start();
                let url = 'order/getOrderSms.do';
                requestPost(this, url, {orderId: row.orderId}).then((res) => {
                    if (res != '') {
                        this.SMSLogVisible = true;
                        this.smsLogDatas.push(res.data);
                    }
                    NProgress.done();
                });
            },

            showMerchantPayDialog() {
                this.batchMerchantPayVisible = true;
                var orderNOs = this.sels.map(item => item.orderNO).toString();
                this.batchMerchantPayForm.orderNOs = orderNOs.replace(/\,/g, '\r\n');

            },

            showCancelDialog(index, row) {
                this.cancelOrderVisible = true;
                this.cancelOrderForm.orderId = row.orderId;

            },

            showPayOrderDialog(index, row) {
                this.payOrderVisible = true;
                this.payOrderForm.orderNOs = row.orderNO;
                this.payOrderForm.userId = row.merchantId;

            },

            showBatchPayOrderDialog() {
                this.payOrderVisible = true;
                if (this.sels.length > 0) {
                    var orderNOs = this.sels.map(item => item.orderNO).toString();
                    this.payOrderForm.orderNOs = orderNOs.replace(/\,/g, '\r\n');
                }


            },

            assignOnlyID(index, row) {
                this.assignIDVisible = true;
                this.assignIDForm.orderId = row.orderId;

            },
            assignIDSubmit() {
                this.$confirm('确认指派该工程师吗?', '提示', {
                    type: 'warning'
                }).then(() => {

                    let para = Object.assign({}, this.assignIDForm);
                    NProgress.start();
                    let url = 'order/assign.do';
                    requestPost(this, url, para).then((res) => {
                        if (res != '') {
                            this.getOrders();
                            this.$message({
                                message: '指派成功!',
                                type: 'success'
                            });
                        }
                        NProgress.done();
                    });
                });
            },


            payOrderSubmit() {
                NProgress.start();
                let url = 'recharge/create.do';
                let para = Object.assign({}, this.payOrderForm);

                let patt1 = new RegExp(/.+/g);//匹配除换行符以外的其它字符
                var subIds = this.payOrderForm.orderNOs.match(patt1).join(',');
                para.orderNOs = subIds;


                para.zfbForward = 0;
                requestPost(this, url, para).then((res) => {
                    if (res != '') {
                        if (res.code == '-1010') {
                            this.$confirm('余额不足，是否选择支付宝继续支付？', '提示', {}).then(() => {
                                para.zfbForward = 1;
                                requestPost(this, url, para).then((res) => {
                                    if (res != '') {
                                        this.$confirm('支付成功？', '提示', {}).then(() => {
                                            this.payOrderVisible = false;
                                            this.getOrders();
                                        });
                                        let routeData = this.$router.resolve({path: 'apply', query: {htmls: res}});
                                        window.open(routeData.href, '_blank');
                                    }
                                });

                            });
                        } else {
                            util.successTip(this);
                        }
                    }
                    NProgress.done();
                });
            },

            getProducts() {
                this.products = [];
                this.addForm.productId = '';
                this.editForm.productId = '';

                if (this.addForm.merchantId == '' && this.editForm.merchantId == '') {
                    if (this.accountType != 2) {

                        this.$message({
                            message: '请先选择所属商家',
                            type: 'warning'
                        });
                    } else {

                        NProgress.start();
                        let url = 'product/getByUserId.do';
                        requestPost(this, url, {}).then((res) => {

                            if (res != '') {
                                this.products = res.data;
                            }

                            NProgress.done();
                        });
                    }

                } else {
                    NProgress.start();
                    let url = 'product/getByUserId.do';
                    requestPost(this, url, {userId: this.addForm.merchantId == '' ? this.editForm.merchantId : this.addForm.merchantId}).then((res) => {

                        if (res != '') {
                            this.products = res.data;
                        }

                        NProgress.done();
                    });
                }


            },

            exportExcel() {
                let that = this;
                this.$refs.token.value = sessionStorage.getItem('token');
                var params = Object.keys(this.filters).map(function (key) {
                    return encodeURIComponent(key) + "=" + encodeURIComponent(that.filters[key]);
                }).join("&");
                this.$refs.exportEx.action = 'order/queryExport.do?' + params;
                console.log(this.$refs.exportEx.action)
                this.$refs.exportEx.submit();

            },

            getReview(id) {
                let para = {orderId: id};
                let url = 'orderReview/getByOrderId.do';
                NProgress.start();
                requestPost(this, url, para).then((res) => {
                    NProgress.done();
                    if (res !== '') {
                        this.reviews = res.data;
                    }
                });
            },

            getProductPrice() {
                if (this.addForm.productId != '' && this.addForm.carTypeId != '') {
                    let para = {productId: this.addForm.productId, carTypeId: this.addForm.carTypeId};
                    let url = 'product/getByProductPrice.do';
                    NProgress.start();
                    requestPost(this, url, para).then((res) => {
                        NProgress.done();
                        if (res !== '') {
                            this.orderMoney = res.data / 100;
                        }
                    });
                }
            },

            editGetProductPrice() {
                if (this.editForm.productId != '' && this.editForm.carTypeId != '') {
                    let para = {productId: this.editForm.productId, carTypeId: this.editForm.carTypeId};
                    let url = 'product/getByProductPrice.do';
                    NProgress.start();
                    requestPost(this, url, para).then((res) => {
                        NProgress.done();
                        if (res !== '') {
                            this.editOrderMoney = res.data / 100;
                        }
                    });
                }
            },


            reviewSubmit() {
                let that = this;
                let para = Object.assign({}, this.reviewForm);
                let url = 'orderReview/add.do';
                NProgress.start();
                requestPost(this, url, para).then((res) => {
                    NProgress.done();
                    if (res !== '') {
                        this.$refs['reviewForm'].resetFields()
                        util.successTip(this);
                        that.getReview(this.reviewForm.orderId);
                    }
                });

            },

            review(index, row) {
                this.reviewVisible = true;
                this.reviewForm.orderId = row.orderId;
                this.getReview(row.orderId);

            },


            showSubsidyDialog(index, row) {
                this.subsidyVisible = true;
                this.subsidyForm.orderId = row.orderId;


            },

            subsidySubmit() {
                this.$confirm('确认提交吗？', '提示', {}).then(() => {

                    NProgress.start();
                    let para = Object.assign({}, this.subsidyForm);
                    para.subsidyMoney = this.subsidyForm.subsidyMoney * 100;

                    let url = 'order/subsidy.do';
                    requestPost(this, url, para).then((res) => {
                        NProgress.done();
                        if (res !== '') {
                            util.successTip(this);
                            this.$refs['subsidyForm'].resetFields();
                            this.subsidyVisible = false;
                            this.getOrders();
                        }
                    });
                });
            },

            showEditOrder(index, row) {

                this.editFormVisible = true;
                this.regionId = [];
                this.regionId = [];
                this.carBrands = [];
                this.carBrandId = '';
                this.products = [];
                this.carTypes = [];


                util.getArea(this, '').then(res => {
                    for (let i = 0; i < res.data.length; i++) {
                        this.addProvinces = res.data;
                        this.$set(this.addProvinces[i], 'cities', []) // right
                    }
                }).then(() => {
                    this.editForm.merchantId = row.merchantId;
                    this.getbrands();
                    this.getProducts();
                }).then(() => {

                    let para = {
                        userType: 2
                    };
                    NProgress.start();
                    let url = 'user/getByUserType.do';
                    requestPost(this, url, para).then((res) => {

                        if (res != '') {

                            this.merchant = res.data;
                        }
                        NProgress.done();
                        this.editForm = Object.assign({}, row);
                        this.editForm.orderMoney = row.orderMoney / 100;

                    });
                });
            },

            editSubmit() {

                this.$confirm('确认提交吗？', '提示', {}).then(() => {
                    this.editLoading = true;
                    NProgress.start();
                    let para = Object.assign({}, this.editForm);
                    if (this.regionId.length > 0) {
                        para.userProvince = this.regionId[0];
                        para.userCity = this.regionId[1];
                        para.userArea = this.regionId[2];
                    }

                    console.log(para);
                    let url = 'order/update.do';
                    requestPost(this, url, para).then((res) => {
                        this.editLoading = false;
                        NProgress.done();
                        if (res !== '') {
                            util.successTip(this);
                            this.$refs['editForm'].resetFields();
                            this.editFormVisible = false;
                            this.filters.userPhone = this.editForm.userPhone;
                            this.getOrders();
                        }
                    });
                });

            },

            merchantPaySubmit() {

                this.$confirm('确认商家已结款?', '提示', {}).then(() => {

                    NProgress.start();
                    let patt1 = new RegExp(/.+/g);//匹配除换行符以外的其它字符
                    let para = {

                        orderNOs: this.batchMerchantPayForm.orderNOs.match(patt1).join(','),
                        merchantPayRemark: this.batchMerchantPayForm.merchantPayRemark,
                        merchantPayState: 1,
                    };
                    var url = "order/merchantPayed.do?t=" + new Date().getTime();
                    requestPost(this, url, para).then((res) => {
                        if (res != '') {

                            NProgress.done();
                            util.successTip(this);
                            this.$refs['batchMerchantPayForm'].resetFields();
                            this.batchMerchantPayVisible = false;
                            this.getOrders();
                        }
                    });
                });

            },

            batchMasterPaySubmit() {
                this.$confirm('确认已结款给工程师?', '提示', {}).then(() => {

                    NProgress.start();
                    let patt1 = new RegExp(/.+/g);//匹配除换行符以外的其它字符
                    let para = {

                        orderNOs: this.batchMasterPayForm.orderNOs.match(patt1).join(','),
                        merchantPayRemark: this.batchMasterPayForm.masterPayRemark,
                        masterPayState: this.batchMasterPayForm.masterPayState
                    };
                    var url = "order/masterPayed.do?t=" + new Date().getTime();
                    requestPost(this, url, para).then((res) => {
                        if (res != '') {

                            NProgress.done();
                            util.successTip(this);
                            this.$refs['batchMasterPayForm'].resetFields();
                            this.batchMasterPayVisible = false;
                            this.getOrders();
                        }
                    });
                });

            },

            drawMark_searchMasterWithMap(res) {
                let that = this;

                that.map = new qq.maps.Map(document.getElementById("container_searchMasterWithMap"), {
                    // 地图的中心地理坐标。
                    zoom: 4
                });

                if (res) {
                    this.masterUsers_searchMasterWithMap = res.data.master;

                    if (res.data.master.length > 0) {
                        var anchor = new qq.maps.Point(0, 39),
                            size = new qq.maps.Size(48, 48),
                            origin = new qq.maps.Point(0, 0),
                            gongMarker = new qq.maps.MarkerImage(
                                that.gongImg,
                                size,
                                origin,
                                anchor
                            ),
                            dingMarker = new qq.maps.MarkerImage(
                                that.dingImg,
                                size,
                                origin,
                                anchor
                            );


                        res.data.master.forEach(function (value, index) {

                            var marker = new qq.maps.Marker({
                                position: new qq.maps.LatLng(value.lat, value.lon),
                                map: that.map
                            });
                            new qq.maps.Label({
                                position: new qq.maps.LatLng(value.lat, value.lon),
                                map: that.map,
                                offset: new qq.maps.Size(48, -28),
                                style: {color: "red"},
                                content: `${value.masterId},距离:${value.distance / 1000}公里`
                            });
                            marker.setIcon(gongMarker);

                        })
                        var marker = new qq.maps.Marker({
                            position: new qq.maps.LatLng(res.data.point.lat, res.data.point.lng),
                            map: that.map,
                        });
                        marker.setIcon(dingMarker);
                        that.map.setCenter(new qq.maps.LatLng(res.data.point.lat, res.data.point.lng));
                        that.map.setZoom(15);
                    } else {
                        var anchor = new qq.maps.Point(0, 39),
                            size = new qq.maps.Size(48, 48),
                            origin = new qq.maps.Point(0, 0),
                            dingMarker = new qq.maps.MarkerImage(
                                that.dingImg,
                                size,
                                origin,
                                anchor
                            );
                        var marker = new qq.maps.Marker({
                            position: new qq.maps.LatLng(res.data.point.lat, res.data.point.lng),
                            map: that.map,
                        });
                        marker.setIcon(dingMarker);
                        that.map.setCenter(new qq.maps.LatLng(res.data.point.lat, res.data.point.lng));
                        that.map.setZoom(15);
                    }
                    //点击地图事件
                    that.registerMapClickEvent(that.map, true)
                }


            },

            drawMark(res) {
                let that = this;
                that.map = new qq.maps.Map(document.getElementById("container"), {
                    // 地图的中心地理坐标。
                    center: new qq.maps.LatLng(res.data.point.lat, res.data.point.lng),
                    zoom: 15
                });
                this.masterUsers = res.data.master;

                if (res.data.master.length > 0) {
                    var anchor = new qq.maps.Point(0, 39),
                        size = new qq.maps.Size(48, 48),
                        origin = new qq.maps.Point(0, 0),
                        gongMarker = new qq.maps.MarkerImage(
                            that.gongImg,
                            size,
                            origin,
                            anchor
                        ),
                        dingMarker = new qq.maps.MarkerImage(
                            that.dingImg,
                            size,
                            origin,
                            anchor
                        );

                    res.data.master.forEach(function (value, index) {

                        var marker = new qq.maps.Marker({
                            position: new qq.maps.LatLng(value.lat, value.lon),
                            map: that.map
                        });
                        new qq.maps.Label({
                            position: new qq.maps.LatLng(value.lat, value.lon),
                            map: that.map,
                            offset: new qq.maps.Size(48, -28),
                            style: {color: "red"},
                            content: `${value.masterId},距离:${value.distance / 1000}公里`
                        });
                        marker.setIcon(gongMarker);

                    })
                    var marker = new qq.maps.Marker({
                        position: new qq.maps.LatLng(res.data.point.lat, res.data.point.lng),
                        map: that.map,
                    });
                    marker.setIcon(dingMarker);
                } else {
                    var anchor = new qq.maps.Point(0, 39),
                        size = new qq.maps.Size(48, 48),
                        origin = new qq.maps.Point(0, 0),
                        dingMarker = new qq.maps.MarkerImage(
                            that.dingImg,
                            size,
                            origin,
                            anchor
                        );
                    var marker = new qq.maps.Marker({
                        position: new qq.maps.LatLng(res.data.point.lat, res.data.point.lng),
                        map: that.map,
                    });
                    marker.setIcon(dingMarker);
                }
                //点击地图事件
                this.registerMapClickEvent(that.map)

            },

            registerMapClickEvent(map, isSearchMasterWithMap) {
                let that = this;
                qq.maps.event.addListener(map, 'click', function (e) {
                    var lat = e.latLng.getLat();
                    var lng = e.latLng.getLng();
                    var anchor = new qq.maps.Point(0, 39),
                        size = new qq.maps.Size(48, 48),
                        origin = new qq.maps.Point(0, 0),
                        dingMarker = new qq.maps.MarkerImage(
                            that.dingImg,
                            size,
                            origin,
                            anchor
                        );
                    var marker = new qq.maps.Marker({
                        position: new qq.maps.LatLng(lat, lng),
                        map: map,
                    });
                    marker.setIcon(dingMarker);

                    that.getNearMasterByLatLng(lat, lng, isSearchMasterWithMap);
                });


            },

            getNearMasterByLatLng(lat, lng, isSearchMasterWithMap) {
                let para = {
                    lat: lat,
                    lon: lng,
                    radius: 20000
                };
                NProgress.start();
                let url = 'order/getNearMaster.do';
                requestPost(this, url, para).then((res) => {
                    if (res != '') {
                        if (isSearchMasterWithMap)
                            this.drawMark_searchMasterWithMap(res);
                        else
                            this.drawMark(res);
                    }
                    NProgress.done();
                })
            },

            getPoi() {
                if (this.assignFilters.address != '') {
                    let para = Object.assign({}, this.assignFilters);
                    NProgress.start();
                    let url = 'master/getNearMaster.do';
                    requestPost(this, url, para).then((res) => {
                        if (res != '') {
                            this.drawMark(res);
                        }
                        NProgress.done();
                    })
                } else {
                    let para = {
                        orderId: this.assignForm.orderId,
                        radius: 20000
                    };
                    NProgress.start();
                    let url = 'order/getNearMaster.do';
                    requestPost(this, url, para).then((res) => {
                        if (res != '') {
                            this.drawMark(res);
                        }
                        NProgress.done();
                    })
                }


            },

            getPoi_searchMasterWithMap() {
                if (this.searchMasterWithMapFilters.address != '') {
                    let para = Object.assign({}, this.searchMasterWithMapFilters);
                    NProgress.start();
                    let url = 'master/getNearMaster.do';
                    requestPost(this, url, para).then((res) => {
                        if (res != '') {
                            this.drawMark_searchMasterWithMap(res);
                        }
                        NProgress.done();
                    })
                } else {
                    this.$message({
                        message: '请输入详细地址查询!',
                        type: 'warning'
                    });
                }
            },

            getOrderInfoInMap() {
                this.orderInfoInMapVisible = true;
            },

            masterDetailOrder(index, row) {
                this.masterDetailOrderVisible = true;
                let para = {
                    rowCount: 10000,
                    pageNO: this.pageNO,
                    state: 2,
                    masterId: row.masterId
                };

                NProgress.start();
                let url = 'order/queryPage.do';
                requestPost(this, url, para).then((res) => {
                    if (res != '') {

                        this.masterDetailOrders = res.data;
                    }
                    NProgress.done();
                });


            },

            searchMasterWithMap() {
                let that = this;
                this.searchMasterWithMapVisible = true;
                TMap('CAMBZ-RHK3U-A77VV-4H76Z-TLOT2-Q4F34').then(qq => {
                    that.drawMark_searchMasterWithMap();
                });
            },

            assign(index, row) {
                let that = this;
                this.orderInfoInMap = row;

                this.assignFormVisible = true;
                this.assignForm.orderId = row.orderId;
                this.assignForm.masterId = row.masterId;


                this.confirmAssignForm.installMoney = parseInt(row.installMoney) >= 0 ? parseInt(row.installMoney) / 100 : 0;

                let para = {
                    orderId: row.orderId,
                    radius: 20000
                };


                NProgress.start();
                let url = 'order/getNearMaster.do';
                requestPost(this, url, para).then((res) => {
                    if (res != '') {

                        TMap('CAMBZ-RHK3U-A77VV-4H76Z-TLOT2-Q4F34').then(qq => {
                            that.drawMark(res);
                        });
                    }
                    NProgress.done();
                })


            },

            sendSMS(index, row) {
                this.$confirm('确认补发短信吗?', '提示', {
                    type: 'warning'
                }).then(() => {
                    NProgress.start();
                    let para = {orderId: row.orderId};
                    let url = 'order/reSendSms.do';
                    requestPost(this, url, para).then((res) => {
                        this.listLoading = false;
                        NProgress.done();
                        if (res != '') {
                            util.successTip(this);
                        }
                    });
                }).catch(() => {

                });
            },

            showConfirmAssign(index, row) {
                this.confirmAssignVisible = true;
                this.confirmAssignForm.masterId = row.masterId;


            },

            finishOrder(index, row) {
                this.$confirm('确认完成订单吗?', '提示', {
                    type: 'warning'
                }).then(() => {
                    NProgress.start();
                    let para = {orderId: row.orderId};
                    let url = 'order/finish.do';
                    requestPost(this, url, para).then((res) => {
                        NProgress.done();
                        if (res != '') {
                            util.successTip(this);
                            this.getOrders();
                        }
                    });
                }).catch(() => {

                });
            },

            confirmAssignSubmit(index, row) {
                this.$confirm('确认派单吗?', '提示', {
                    type: 'warning'
                }).then(() => {

                    let para = {
                        //installMoney: this.confirmAssignForm.installMoney * 100,
                        orderId: this.assignForm.orderId,
                        masterId: row.masterId
                    }
                    NProgress.start();
                    let url = 'order/assign.do';
                    requestPost(this, url, para).then((res) => {
                        if (res != '') {
                            //this.confirmAssignVisible = false;
                            //this.$refs['confirmAssignForm'].resetFields();
                            this.getOrders();
                            this.$message({
                                message: '派单成功!',
                                type: 'success'
                            });
                        }
                        NProgress.done();
                    });
                });
            },

            select_ChangeEvent(val) {

                if (val.length == 1) {
                    util.getArea(this, val[0]).then(res => {
                        this.addProvinces.map((value, i) => {
                            if (value.region_id === val[0]) {
                                if (!value.cities.length) {
                                    value.cities = res.data.map((value, i) => {
                                        return {
                                            region_id: value.region_id,
                                            region_name: value.region_name,
                                            cities: []
                                        }
                                    })
                                }
                            }
                        })
                    })
                } else if (val.length === 2) {
                    util.getArea(this, val[1]).then(res => {
                        this.addProvinces.map((value, i) => {
                            if (value.region_id === val[0]) {
                                value.cities.map((value, i) => {
                                    if (value.region_id === val[1]) {
                                        if (!value.cities.length) {
                                            value.cities = res.data.map((value, i) => {
                                                return {
                                                    region_id: value.region_id,
                                                    region_name: value.region_name
                                                }
                                            })
                                        }
                                    }
                                })
                            }
                        })
                    })

                }


            },

            queryMerchant: function (row) {
                this.$router.push({path: '/merchant', query: {merchantId: row.merchantId}})

            },

            queryCommonUser: function (row) {
                this.$router.push({path: '/worker', query: {workerId: row.workerId}})

            },

            queryMasterUser: function (row) {
                this.$router.push({path: '/masterUser', query: {masterId: row.masterId}})
            },

            queryImage: function (row) {
                if (typeof row.installPic != 'undefined' && row.installPic.length > 0) {
                    this.queryImageVisible = true;

                    this.images = row.installPic.split(";").map(function (value, i) {
                        return `../image/getByImageId.do?imageId=${value}`
                    });
                } else
                    this.$message({
                        message: '暂未上传图片',
                        type: 'error'
                    });
            },

            handleCurrentChange(val) {
                this.pageNO = val;
                this.getOrders();
            },
            recoverOrder(index, row) {

                this.$confirm('确认恢复该订单吗?', '提示', {
                    type: 'warning'
                }).then(() => {

                    NProgress.start();
                    let para = {orderId: row.orderId};
                    let url = 'order/recovery.do';
                    requestPost(this, url, para).then((res) => {

                        NProgress.done();
                        if (res != '') {
                            util.successTip(this);
                            this.getOrders();
                        }
                    });
                }).catch(() => {

                });

            },


            getOrders(isAll) {

                let para = {
                    rowCount: this.rowCount,
                    pageNO: this.pageNO
                };

                if (this.date != '') {
                    this.filters.orderStartTime = util.formatDate.format(new Date(this.date[0]), 'yyyy-MM-dd hh:mm:ss');
                    this.filters.orderEndTime = util.formatDate.format(new Date(this.date[1]), 'yyyy-MM-dd hh:mm:ss');
                }
                para = Object.assign(para, this.filters);
                console.log(this.filters.state);
                if (isAll === true)
                    para.state = '';
                else if (this.filters.state === '')
                    para.state = 100;


                this.listLoading = true;
                NProgress.start();
                let url = 'order/queryPage.do';
                requestPost(this, url, para).then((res) => {
                    if (res != '') {
                        this.total = res.total;
                        this.orders = res.data;
                    }
                    this.listLoading = false;
                    NProgress.done();
                });
            },


            //取消订单
            cancelOrderSubmit: function (index, row) {
                this.$confirm('确认退订该订单吗?', '提示', {
                    type: 'warning'
                }).then(() => {

                    NProgress.start();
                    let para = Object.assign({}, this.cancelOrderForm);
                    let url = 'order/cancel.do';
                    requestPost(this, url, para).then((res) => {

                        NProgress.done();
                        if (res != '') {
                            this.cancelOrderVisible = false;
                            this.$refs['cancelOrderForm'].resetFields();
                            util.successTip(this);
                            this.getOrders();
                        }
                    });
                }).catch(() => {

                });
            },

            //显示新增界面
            handleAdd: function () {
                let that = this;
                this.addFormVisible = true;
                this.regionId = [];
                this.carBrands = [];
                this.carBrandId = '';
                this.products = [];
                this.carTypes = [];
                this.addForm.merchantId = '';
                util.getArea(this, '').then(res => {
                    for (let i = 0; i < res.data.length; i++) {
                        this.addProvinces = res.data;
                        this.$set(this.addProvinces[i], 'cities', []) // right
                    }
                }).then(() => {

                    let para = {
                        userType: 2
                    };
                    NProgress.start();
                    let url = 'user/getByUserType.do';
                    requestPost(this, url, para).then((res) => {

                        if (res != '') {

                            this.merchant = res.data;
                        }
                        NProgress.done();
                    });
                }).then(() => {
                    if (that.accountType == 2)
                        that.getProducts();
                    that.getbrands();
                });

            },

            getbrands() {

                NProgress.start();
                let url = 'carBrand/getAll.do';
                requestPost(this, url, {}).then((res) => {

                    if (res != '') {
                        this.carBrands = res.data;
                    }

                    NProgress.done();
                });
            },

            getCarTypes() {
                this.carTypes = [];
                this.editForm.carTypeId = '';
                this.addForm.carTypeId = '';
                NProgress.start();
                let url = 'carType/getByCarBrand.do';
                requestPost(this, url, {carBrandId: this.carBrandId}).then((res) => {

                    if (res != '') {
                        this.carTypes = res.data;
                    }

                    NProgress.done();
                });
            },


            addSubmit: function () {
                this.$refs.addForm.validate((valid) => {
                    if (valid) {
                        this.$confirm('确认提交吗？', '提示', {}).then(() => {
                            this.addLoading = true;
                            NProgress.start();
                            let para = Object.assign({}, this.addForm);
                            para.userProvince = this.regionId[0];
                            para.userCity = this.regionId[1];
                            para.userArea = this.regionId[2];
                            let url = 'order/add.do';
                            requestPost(this, url, para).then((res) => {
                                this.addLoading = false;
                                NProgress.done();
                                if (res !== '') {
                                    util.successTip(this);
                                    this.$refs['addForm'].resetFields();
                                    this.addFormVisible = false;
                                    this.filters.userPhone = this.addForm.userPhone;
                                    this.getOrders();
                                }
                            });
                        });
                    }
                });
            },

            selsChange: function (sels) {
                this.sels = [];
                this.sels = sels;

            }

        },
        watch: {
            '$route'(to, from) {
                let query = to.query;
                if (typeof query.index != 'undefined') {
                    if (query.index == 1)
                        this.filters.provinceIds = '10,18,15,12,31,19';
                    else if (query.index == 2) {
                        this.filters.provinceIds = '26,3,22,14,13,7,4,20,11';
                    } else if (query.index == 3) {
                        this.filters.provinceIds = '27,25,9,30,17,16,29,28,21';
                    }else if (query.index == 4) {
                        this.filters.provinceIds = '6,32,2';
                    }else if (query.index == 5) {
                        this.filters.provinceIds = '23,8,24,5';
                    }
                } else
                    this.filters.provinceIds = ''
                this.getOrders();
            }
        },
        mounted() {
            let query = this.$route.query;
            if (typeof query.userId !== 'undefined') {
                this.filters.merchantId = this.$route.query.userId;
                this.getOrders(true);
            } else if (typeof query.masterId !== 'undefined') {
                this.filters.masterId = this.$route.query.masterId;
                this.filters.state = 2;
                this.getOrders();
            } else
                this.getOrders();

        },

        activated: function () {

        },
        created() {
            let _this = this;
            util.getArea(this, '').then(res => {
                this.provinces = res.data;
            });
        }
    }

</script>


<style scope lang="scss" type="text/scss">
    @import '../../styles/vars.scss';

    .el-select__input {

        vertical-align: baseline;

    }

    .map {
        width: 100%;
        height: 400px;
    }

    .assignWidth {
        width: 1400px;
    }

    .dd {
        color: #f4516c;
        font-weight: 600
    }

    .el-cascader-menu {
        height: 700px;
    }

</style>


// WEBPACK FOOTER //
// installOrder.vue?62cf070c